import { Fragment } from 'react';

import LessonCard from './LessonCard';
import { makeStyles } from '@material-ui/core/styles';
import { ILesson } from 'interface/lesson';

interface IProps {
  lessons: ILesson[];
  selectedLesson: number;
  moduleIndex: number;
}

const useStyles = makeStyles((theme) => ({
  notFoundLesson: {
    minHeight: 56,
    padding: 16,
    fontStyle: 'italic',
  },
}));

const LessonCardList = ({ lessons, selectedLesson, moduleIndex }: IProps) => {
  const classes = useStyles();
  return (
    <Fragment>
      {!lessons.length && <span className={classes.notFoundLesson}>Nenhuma aula encontrada</span>}

      {!!lessons &&
        lessons.map((lesson: any, key: number) => (
          <LessonCard selected={selectedLesson === lesson.id} moduleIndex={moduleIndex} key={key} lesson={lesson} />
        ))}
    </Fragment>
  );
};

export default LessonCardList;
